import React from 'react';

type ProgressiveImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  hasAvif?: boolean;
  hasWebp?: boolean;
  localPath?: string; // provided if image is stored in vite public/images folder
  src?: string; // provided if image is stored remotely
};

const environment = import.meta.env.VITE_ENVIRONMENT as string;
const envPath = environment === 'test_sf' ? 'rrssf/' : ['development', 'test', 'prod'].includes(environment) ? 'rrs/' : '';

const ProgressiveImage = ({
  hasAvif = false,
  hasWebp = false,
  localPath = '',
  src = '',
  ...imgProps
}: ProgressiveImageProps) => {
  if (!src && !localPath) {
    return null;
  }

  const isLocalPath = Boolean(localPath);
  const url = isLocalPath ? `/${envPath}images/${localPath}` : src;
  const urlMinusExtension = url.split('.').slice(0, -1).join('.');
  const providedExtension = url.split('.').pop()?.toLowerCase();

  // SVGs do not have AVIF or WebP versions
  if (providedExtension === 'svg') {
    return <img src={`${urlMinusExtension}.svg`} {...imgProps} />;
  }

  return (
    <picture>
      {hasAvif && <source srcSet={`${urlMinusExtension}.avif`} type='image/avif' />}
      {hasWebp && <source srcSet={`${urlMinusExtension}.webp`} type='image/webp' />}
      <img src={`${urlMinusExtension}.${providedExtension}`} {...imgProps} />
    </picture>
  );
};

export default ProgressiveImage;
